export default __webpack_public_path__ + "static/media/Avatar-25.0e8c8325.svg";